import { CalendarDays, Clock, ExternalLink, MapPin } from "lucide-react";
const {
  formatEventDate,
  formatEventTime,
  isEventToday,
} = require("../../lib/market-schedule");

function trackMarketScheduleMapClick(event) {
  if (typeof window === "undefined") {
    return;
  }

  import("posthog-js")
    .then((module) => {
      const posthog = module.default || module;

      if (posthog && typeof posthog.capture === "function") {
        posthog.capture("market_schedule_map_click", {
          event_id: event.eventId,
          event_day_id: event.eventDayId,
          title: event.title,
          date: event.date,
        });
      }
    })
    .catch(() => {});
}

export default function MarketScheduleEventCard({ event, compact = false }) {
  const today = isEventToday(event);
  const location = event.locationName || event.address;
  const locationContent = (
    <>
      {event.locationName ? <div>{event.locationName}</div> : null}
      {event.address && !compact ? <div className="font-medium text-chocolate/70">{event.address}</div> : null}
    </>
  );

  return (
    <article className="h-full rounded-lg border border-chocolate/15 bg-white/85 p-5 shadow-sm">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2 text-sm font-bold text-crimson">
            <span className="inline-flex items-center gap-1.5">
              <CalendarDays className="h-4 w-4" aria-hidden="true" />
              {formatEventDate(event.date)}
            </span>
            {today ? (
              <span className="rounded-full bg-crimson px-2.5 py-1 text-xs font-bold uppercase tracking-wide text-white">
                Today
              </span>
            ) : null}
          </div>
          <h3 className="mt-2 text-xl font-bold leading-tight text-chocolate">{event.title}</h3>
        </div>

        <div className="inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-cream px-3 py-2 text-sm font-bold text-chocolate">
          <Clock className="h-4 w-4" aria-hidden="true" />
          {formatEventTime(event.openTime, event.closeTime)}
        </div>
      </div>

      {location ? (
        <div className="mt-4 flex items-start gap-2 text-sm font-semibold text-chocolate/85">
          <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-crimson" aria-hidden="true" />
          {event.mapUrl ? (
            <a
              className="rounded-sm underline decoration-chocolate/30 underline-offset-4 transition hover:text-crimson hover:decoration-crimson focus:outline-none focus-visible:ring-2 focus-visible:ring-crimson/35"
              href={event.mapUrl}
              onClick={() => trackMarketScheduleMapClick(event)}
              rel="noopener noreferrer"
              target="_blank"
            >
              {locationContent}
            </a>
          ) : (
            <div>{locationContent}</div>
          )}
        </div>
      ) : null}

      {event.summary && !compact ? (
        <p className="mt-4 text-sm leading-6 text-chocolate/80">{event.summary}</p>
      ) : null}

      {event.mapUrl ? (
        <a
          className="mt-5 inline-flex min-h-11 items-center justify-center gap-2 rounded-lg bg-chocolate px-4 py-2.5 text-sm font-bold text-white transition hover:bg-black focus:outline-none focus-visible:ring-2 focus-visible:ring-chocolate/40 focus-visible:ring-offset-2"
          href={event.mapUrl}
          onClick={() => trackMarketScheduleMapClick(event)}
          rel="noopener noreferrer"
          target="_blank"
        >
          Map
          <ExternalLink className="h-4 w-4" aria-hidden="true" />
        </a>
      ) : null}
    </article>
  );
}
